// extracted by css-extract-rspack-plugin
export default {"feedbackLinkWrapper":"CollapsibleFeedbackLink-module__feedbackLinkWrapper__C0eI5"};